import styled from 'styled-components'
export const DocumentManagementTabLayout = styled.div`
    display: flex;
`

export const DocumentManagementTabContent = styled.div`
    width: 100%;
`